import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { CommunitiesModal } from "./Modal";

const MyCommunitiesModal = ModalManager.create(() => <CommunitiesModal />);

export const useSeeMyCommunitiesModal = () => useModal(MyCommunitiesModal);
